module.exports = __webpack_public_path__ + "img/welcome-mockup.0adec35a.png";